'use client'
import { useTranslations } from '@/lib/next-shim'
import colors from 'tailwindcss/colors'

import { CheckRoundedIcon } from '@/components/external/icons-material'
import { Avatar } from '@/components/external/material'

export function RegisterSuccess() {
  const t = useTranslations()

  return (
    <div className="h-full flex flex-1 items-start justify-center">
      <div className="sm:rounded-lg bg-white shadow h-full sm:h-auto w-full sm:w-[484px] sm:mt-5 px-6 py-10">
        <div className="flex flex-col items-center space-y-6 text-center">
          <Avatar className="bg-green-100 h-12 w-12">
            <CheckRoundedIcon htmlColor={colors.green['600']} />
          </Avatar>
          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-gray-900">{t('page.Register.signUpSuccess')}</h1>
          </div>
        </div>
      </div>
    </div>
  )
}
